import '@tencent/exeditor3-ui-kit/dist/toolbar-select.js';
import { createIcon, } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { defaultOption } from './data.js';
export class TextAlignPlugin {
    constructor(opt) {
        this.name = 'textAlign';
        this.set = (v) => {
            this.editor.selection(true).updateNodeAttr(this.opt.target, this.name, v);
        };
        this.get = () => { var _a; return (_a = this.editor.selection().getNodeAttr(this.opt.target, this.name)) !== null && _a !== void 0 ? _a : null; };
        this.canApply = () => this.editor.selection().hasNode(this.opt.target);
        this.opt = {
            ...defaultOption,
            ...opt,
        };
        this.specExtraAttrs = {
            textAlign: {
                target: this.opt.target,
                parse: (elt) => elt.style.textAlign || null,
                toDOMAttribute: (textAlign) => ({
                    style: textAlign ? `text-align: ${textAlign}` : '',
                }),
            },
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                set: this.set,
                get: this.get,
            },
            shortcuts: {
                'Mod-Shift-l': () => this.set('left'),
                'Mod-Shift-e': () => this.set('center'),
                'Mod-Shift-r': () => this.set('right'),
                'Mod-Shift-j': () => this.set('justify'),
            },
        };
    }
    renderToolbarItem() {
        const t = this.editor.t.bind(this.editor);
        const select = document.createElement('exeditor-toolbar-select');
        Object.assign(select, {
            label: t('对齐'),
            separateDropdown: true,
        });
        const iconWrapper = document.createElement('span');
        select.appendChild(iconWrapper);
        this.opt.options.forEach((config) => {
            const option = document.createElement('exeditor-toolbar-option');
            Object.assign(option, {
                slot: 'option',
                value: config.value,
                onclick: () => {
                    this.editor.focus();
                    this.set(config.value);
                },
            });
            const iconName = `${config.value}TextAlign`;
            const icon = createIcon({
                name: iconName,
                editor: this.editor,
                fallback: () => import('./icon.js').then((m) => m[`${iconName}Icon`]),
            });
            const wrap = document.createElement('span');
            Object.assign(wrap.style, {
                display: 'flex',
                'align-items': 'center',
            });
            const iconWrap = document.createElement('span');
            Object.assign(iconWrap.style, {
                display: 'flex',
                width: '20px',
                marginRight: '8px',
            });
            iconWrap.appendChild(icon);
            wrap.appendChild(iconWrap);
            wrap.appendChild(new Text(t(config.label)));
            option.appendChild(wrap);
            select.appendChild(option);
        });
        const setBtnProps = () => {
            const newIconName = `${this.get() || this.opt.default}TextAlign`;
            const oldIcon = iconWrapper.firstChild;
            if ((oldIcon === null || oldIcon === void 0 ? void 0 : oldIcon.name) !== newIconName) {
                const newIcon = createIcon({
                    name: newIconName,
                    editor: this.editor,
                    fallback: () => import('./icon.js').then((m) => m[`${newIconName}Icon`]),
                });
                if (iconWrapper.firstChild) {
                    iconWrapper.replaceChild(newIcon, oldIcon);
                }
                else {
                    iconWrapper.appendChild(newIcon);
                }
            }
            select.disabled = !this.canApply();
        };
        setBtnProps();
        this.editor.on('idlechange', setBtnProps);
        return select;
    }
}
//# sourceMappingURL=index.js.map